import { render, staticRenderFns } from "./disposal.vue?vue&type=template&id=49e0782c&"
import script from "./disposal.vue?vue&type=script&lang=js&"
export * from "./disposal.vue?vue&type=script&lang=js&"
import style0 from "./disposal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports